import strings from '../../../localization';
import { withSnackbar } from 'notistack';
import * as Actions from "../../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import SpecificationReportPage from './SpecificationReportPage';
import { generateMonthlyCremationReport } from '../../../services/report/ReportService';

class MonthlyCremationReport extends SpecificationReportPage {

  getFields() {
    return ['period'];
  }

  getService() {
    return generateMonthlyCremationReport;
  }

  getFileName() {
    return "1A-mesecni-izvestaj-kremacije";
  }

  getPageTitle() {
    return strings.specificationReports.monthlyCremationTitle;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(MonthlyCremationReport)));
